import { useState } from 'react';
import { Clock, Plus } from '../../icons/wp-icons';
import TimerWidget from './TimerWidget';
import ZeiterfassungListe from './ZeiterfassungListe';
import ManuelleEingabe from './ManuelleEingabe';
import { zeiterfassungApi } from '../../api/zeiterfassungApi';
import apiClient from '../../api/apiClient';

function TerminZeiterfassung({ terminId, kundeId }) {
  const [showManuelleEingabe, setShowManuelleEingabe] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleUpdate = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleZeitToRechnung = async (zeit) => {
    // Prüfen ob es bereits eine offene Rechnung für den Kunden gibt
    if (!kundeId) {
      alert('Zeiterfassung kann nur für Termine mit Kunden in Rechnung übernommen werden.');
      return;
    }

    try {
      // Offene Rechnungen des Kunden laden
      const response = await apiClient.get('/rechnungen', {
        params: { kundeId, status: 'entwurf' }
      });

      const offeneRechnungen = response.data || [];

      if (offeneRechnungen.length === 0) {
        // Keine offene Rechnung vorhanden - fragen ob neue erstellt werden soll
        const createNew = confirm(
          'Keine offene Rechnung vorhanden.\n\nMöchten Sie eine neue Rechnung erstellen?'
        );

        if (!createNew) return;

        // Zeiterfassungs-Daten für die erste Position vorbereiten
        const stunden = zeit.gesamtminuten / 60;
        const beschreibung = zeit.katalogPosition
          ? `${zeit.katalogPosition.bezeichnung}${zeit.notiz ? ` - ${zeit.notiz}` : ''}`
          : `Arbeitszeit${zeit.notiz ? ` - ${zeit.notiz}` : ''}`;

        const einzelpreisInCent = Math.round(zeit.stundensatz * 100);
        const mwstSatz = zeit.katalogPosition?.mwstSatz || 19.0;

        // Neue Rechnung erstellen mit Zeiterfassungs-Position
        const neueRechnung = await apiClient.post('/rechnungen', {
          kundeId,
          positionen: [{
            beschreibung,
            menge: Math.round(stunden * 100) / 100, // auf 2 Dezimalstellen runden
            einheit: 'Std',
            einzelpreis: einzelpreisInCent,
            ustSatz: mwstSatz
          }]
        });

        // Zeiterfassung als übernommen markieren
        await zeiterfassungApi.toRechnung(zeit.id, neueRechnung.data.rechnung.id);
        alert(`Zeiterfassung in neue Rechnung ${neueRechnung.data.rechnung.rechnungsnummer} übernommen!`);
      } else if (offeneRechnungen.length === 1) {
        // Genau eine offene Rechnung - direkt verwenden
        const rechnung = offeneRechnungen[0];
        const confirm_msg = confirm(
          `Zeiterfassung in Rechnung ${rechnung.rechnungsnummer} übernehmen?`
        );

        if (!confirm_msg) return;

        await zeiterfassungApi.toRechnung(zeit.id, rechnung.id);
        alert(`Zeiterfassung in Rechnung ${rechnung.rechnungsnummer} übernommen!`);
      } else {
        // Mehrere offene Rechnungen - Auswahl anbieten
        const rechnungAuswahl = offeneRechnungen.map((r, i) =>
          `${i + 1}. ${r.rechnungsnummer} (${new Date(r.datum).toLocaleDateString('de-DE')})`
        ).join('\n');

        const auswahl = prompt(
          `Mehrere offene Rechnungen gefunden:\n\n${rechnungAuswahl}\n\nNummer eingeben (1-${offeneRechnungen.length}):`
        );

        if (!auswahl) return;

        const index = parseInt(auswahl) - 1;
        if (isNaN(index) || index < 0 || index >= offeneRechnungen.length) {
          alert('Ungültige Auswahl');
          return;
        }

        const rechnung = offeneRechnungen[index];
        await zeiterfassungApi.toRechnung(zeit.id, rechnung.id);
        alert(`Zeiterfassung in Rechnung ${rechnung.rechnungsnummer} übernommen!`);
      }

      handleUpdate();
    } catch (error) {
      console.error('Fehler beim Übernehmen in Rechnung:', error);
      alert(error.response?.data?.error || 'Fehler beim Übernehmen in Rechnung');
    }
  };

  return (
    <div className="border-t border-gray-200 pt-4 mt-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-primary" />
          <h3 className="font-semibold text-gray-900">Zeiterfassung</h3>
        </div>
        <button
          onClick={() => setShowManuelleEingabe(true)}
          className="flex items-center gap-1 text-sm text-primary hover:text-primary-dark transition"
        >
          <Plus className="w-4 h-4" />
          Manuell eintragen
        </button>
      </div>

      {/* Timer Widget */}
      <div className="mb-4">
        <TimerWidget terminId={terminId} onUpdate={handleUpdate} />
      </div>

      {/* Zeiterfassungs-Liste */}
      <ZeiterfassungListe
        terminId={terminId}
        refreshKey={refreshKey}
        onSelectForRechnung={kundeId ? handleZeitToRechnung : null}
      />

      {/* Manuelle Eingabe Modal */}
      {showManuelleEingabe && (
        <ManuelleEingabe
          terminId={terminId}
          onClose={() => setShowManuelleEingabe(false)}
          onSuccess={() => {
            setShowManuelleEingabe(false);
            handleUpdate();
          }}
        />
      )}
    </div>
  );
}

export default TerminZeiterfassung;
